import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#636366",
      "fill-rule": "evenodd",
      d: "M7.958 20.79a.99.99 0 0 1-.439-.657.92.92 0 0 1 .214-.741L14.03 12 7.733 4.608a.92.92 0 0 1-.214-.74.99.99 0 0 1 .439-.658c.118-.082.255-.142.4-.176a1.26 1.26 0 0 1 .867.108q.194.105.33.267l6.658 7.812c.191.224.295.498.295.779s-.104.555-.295.78l-6.658 7.81q-.136.164-.33.268a1.26 1.26 0 0 1-.867.108 1.2 1.2 0 0 1-.4-.175Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }